'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _fileExtension = require('file-extension');

var _fileExtension2 = _interopRequireDefault(_fileExtension);

var _createApi = require('./create.api.document');

var _createApi2 = _interopRequireDefault(_createApi);

var _deleteApi = require('./delete.api.document');

var _deleteApi2 = _interopRequireDefault(_deleteApi);

var _api = require('../../driver/api');

var _api2 = require('../../rental/api');

var _api3 = require('../../vehicle/api');

var _api4 = require('../../medallion/api');

var _attributes = require('../attributes');

var _errors = require('../errors');

var _createdEvent = require('../events/created.event.document');

var _preparations = require('../preparations');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Helpers
// Events
// Attributes
// Api


var updateApi = {
  driver: _api.update,
  rental: _api2.update,
  vehicle: _api3.update,
  medallion: _api4.update
}; // Preparation
// Errors

exports.default = (0, _asyncToGenerator3.default)(
/*#__PURE__*/
_regenerator2.default.mark(function _callee() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$doc = _ref2.doc,
      doc = _ref2$doc === undefined ? null : _ref2$doc,
      _ref2$file = _ref2.file,
      file = _ref2$file === undefined ? null : _ref2$file,
      _ref2$driver = _ref2.driver,
      driver = _ref2$driver === undefined ? null : _ref2$driver,
      _ref2$vehicle = _ref2.vehicle,
      vehicle = _ref2$vehicle === undefined ? null : _ref2$vehicle,
      _ref2$rental = _ref2.rental,
      rental = _ref2$rental === undefined ? null : _ref2$rental,
      _ref2$medallion = _ref2.medallion,
      medallion = _ref2$medallion === undefined ? null : _ref2$medallion,
      _ref2$data = _ref2.data,
      data = _ref2$data === undefined ? {} : _ref2$data,
      _ref2$rawDocumentData = _ref2.rawDocumentData,
      rawDocumentData = _ref2$rawDocumentData === undefined ? {} : _ref2$rawDocumentData,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? null : _ref2$type,
      _ref2$duplicates = _ref2.duplicates,
      duplicates = _ref2$duplicates === undefined ? [] : _ref2$duplicates,
      _ref2$upload = _ref2.upload,
      upload = _ref2$upload === undefined ? true : _ref2$upload;

  var combinedData, object, preparedData, objectID, extension, _Object$entries$filte, fileData, objectData, fileName, formMeta, dynamicFormData, fileResponses, objectResponse;

  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(!doc && upload)) {
            _context.next = 2;
            break;
          }

          throw (0, _errors.missingDoc)({
            message: 'Please select a document to upload'
          });

        case 2:
          if (file) {
            _context.next = 4;
            break;
          }

          throw (0, _errors.missingFile)({
            message: 'No file specified'
          });

        case 4:
          combinedData = (0, _extends5.default)({
            driver: driver,
            vehicle: vehicle,
            rental: rental,
            medallion: medallion,
            duplicates: duplicates
          }, data);
          object = {
            driver: driver,
            rental: rental,
            vehicle: vehicle,
            medallion: medallion
          }[type];

          if (object) {
            _context.next = 8;
            break;
          }

          throw (0, _errors.undefinedObject)({
            message: 'Please provide a reference object "' + type + '"'
          });

        case 8:
          if (!(file.selection.includes('driver') && !driver)) {
            _context.next = 10;
            break;
          }

          throw (0, _errors.missingRequiredObject)({
            message: 'Please select a driver'
          });

        case 10:
          if (!(file.selection.includes('rental') && !rental)) {
            _context.next = 12;
            break;
          }

          throw (0, _errors.missingRequiredObject)({
            message: 'Please select a rental'
          });

        case 12:
          if (!(file.selection.includes('vehicle') && !vehicle)) {
            _context.next = 14;
            break;
          }

          throw (0, _errors.missingRequiredObject)({
            message: 'Please select a vehicle'
          });

        case 14:
          _context.next = 16;
          return (0, _preparations.upload)(data, (0, _keys2.default)(data).filter(function (required) {
            return !file.optionalAttributes.includes(required);
          }));

        case 16:
          preparedData = _context.sent;
          file.preSaveValidation(combinedData);

          if (upload) {
            _context.next = 20;
            break;
          }

          return _context.abrupt('return', null);

        case 20:
          objectID = object.id;
          extension = (0, _fileExtension2.default)(doc.name);
          _Object$entries$filte = (0, _entries2.default)(preparedData).filter(function (_ref3) {
            var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
                key = _ref4[0];

            return key !== _attributes.filename.attribute;
          }).reduce(function (combined, _ref5) {
            var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
                key = _ref6[0],
                value = _ref6[1];

            var dataType = file.fileAttributes.includes(key) ? 'fileData' : 'objectData';
            return (0, _extends5.default)({}, combined, (0, _defineProperty3.default)({}, dataType, (0, _extends5.default)({}, combined[dataType], (0, _defineProperty3.default)({}, key, value))));
          }, {
            fileData: {},
            objectData: {}
          }), fileData = _Object$entries$filte.fileData, objectData = _Object$entries$filte.objectData;
          fileName = file.fileName((0, _extends5.default)({}, combinedData, {
            extension: extension
          }));
          formMeta = new FormData();
          formMeta.append('document_file', doc, fileName);
          formMeta.append('name', fileName);
          if (!!driver) formMeta.append('driver', driver.id);
          if (!!vehicle) formMeta.append('vehicle', vehicle.id);
          if (!!rental) formMeta.append('rental', rental.id);
          if (!!medallion) formMeta.append('medallion', medallion.id);
          formMeta.append('type', file.type);
          formMeta.append('extra_data', (0, _stringify2.default)((0, _extends5.default)({}, objectData, fileData, rawDocumentData)));
          dynamicFormData = file.dynamicFormData(combinedData);
          _context.next = 36;
          return _promise2.default.all(!!dynamicFormData ? dynamicFormData.map(function (dfd) {
            (0, _entries2.default)(dfd).forEach(function (_ref7) {
              var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
                  key = _ref8[0],
                  val = _ref8[1];

              return formMeta.append(key, val);
            });
            return (0, _createApi2.default)(formMeta, false);
          }) : [(0, _createApi2.default)(formMeta, false)]);

        case 36:
          fileResponses = _context.sent;
          objectResponse = null;

          if (!(!!(0, _keys2.default)(objectData).length || !!(0, _keys2.default)(file.defaultObjectData).length)) {
            _context.next = 50;
            break;
          }

          _context.prev = 39;
          _context.next = 42;
          return updateApi[type](objectID, (0, _extends5.default)({}, objectData, file.defaultObjectData));

        case 42:
          objectResponse = _context.sent;
          _context.next = 50;
          break;

        case 45:
          _context.prev = 45;
          _context.t0 = _context['catch'](39);
          _context.next = 49;
          return _promise2.default.all(fileResponses.map(function (_ref9) {
            var id = _ref9.id;
            return (0, _deleteApi2.default)(id);
          }));

        case 49:
          throw _context.t0;

        case 50:
          _context.next = 52;
          return file.postSave((0, _extends5.default)({
            driver: driver,
            rental: rental,
            vehicle: vehicle
          }, preparedData));

        case 52:
          fileResponses.forEach(function (fileResp) {
            return (0, _createdEvent.pub)(fileResp);
          });
          return _context.abrupt('return', {
            files: fileResponses,
            object: objectResponse
          });

        case 54:
        case 'end':
          return _context.stop();
      }
    }
  }, _callee, undefined, [[39, 45]]);
}));